import $ from "jquery"

$('.js-project-sidebar').each(function(){
    $(this).on('click', function(){
        $('.js-project-sidebar').removeClass('active');
        $(this).addClass('active');
        $(this).toggleClass('mobile-active');
        $(this).siblings().removeClass('mobile-active');
    });
});

var lastId,
    sidebarMenu = $(".js-project-sidebar"),
    sidebarMenuHeight = 100,
    menuItems = sidebarMenu.find(".project-flow__sidebar-title"),
    scrollItems = menuItems.map(function(){
        var item = $($(this).attr("href"));
        if (item.length) { return item; }
    });

// Bind to scroll
$(window).on('scroll', function(){
    // Get container scroll position
    var fromTop = $(this).scrollTop() + sidebarMenuHeight;

    // Get id of current scroll item
    var cur = scrollItems.map(function(){
        if ($(this).offset().top < fromTop){
            return this;
        }
    });

    // Get the id of the current element
    if(cur.length == 0){
        $('.js-project-first').addClass('active');
    }

    cur = cur[cur.length-1];
    var id = cur && cur.length ? cur[0].id : "";

    if (lastId !== id) {
        lastId = id;
        // Set/remove active class
        menuItems.parent().removeClass("active").end().filter("[href='#" + id + "']").parent().addClass("active");
    }    
});